import { closeCurrentWebView } from "@/utils/native/interaction";
import { getThemeBgColor } from "@/utils/project";

export default [
  {
    path: "/wt-integral-detail",
    name: "IntegralDetail",
    meta: {
      title: "积分明细",
      showIntegralTitle: true,
      showIntegralDetail: true,
      customBackFn: closeCurrentWebView,
      theme: "transparent-dark",
      keepAlive: true,
      background: getThemeBgColor //"var(--theme-color--)" //"linear-gradient(to right, #FFD700, #FFCA00)"
    },
    component: () =>
      import(
        /* webpackChunkName: "integral" */ "@/views/mine/integral/IntegralDetail.vue"
      )
  }
];
